import { $el, $list } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'

export class RecentlyViewed extends BaseComponent {
  defaultCardsLimit: number
  defaultCardImgRatio: string
  defaultCardAlignment: string

  containerAttribute: string
  localStorageSelector: string
  cardTemplateSelector: string

  cardLimit: number
  cardImgRatio: string
  cardAlignment: string

  cardSelector: string
  cardAlignmentClass: string
  cardInnerSelector: string
  shapeClass: string

  products: HTMLElement[]
  containers: HTMLElement[]

  static localStorageSelector: string = 'AuroraTheme-RecentlyViewed'
  static defaultLimit: number = 50

  constructor() {
    super()

    this.defaultCardsLimit = RecentlyViewed.defaultLimit
    this.defaultCardImgRatio = 'portrait'
    this.defaultCardAlignment = 'left'

    this.containerAttribute = '[recently-viewed-container]'
    this.localStorageSelector = RecentlyViewed.localStorageSelector
    this.cardTemplateSelector = 'product-card-template'

    this.cardLimit = +this.dataset.cardLimit ?? this.defaultCardsLimit
    this.cardImgRatio = this.dataset.imgRatio ?? this.defaultCardImgRatio
    this.cardAlignment = this.dataset.cardAlignment ?? this.defaultCardAlignment

    this.cardSelector = 'product-card'
    this.cardAlignmentClass = `product-card--${this.cardAlignment}-alignment`
    this.cardInnerSelector = '[data-product-card-inner]'
    this.shapeClass = `shape--${this.cardImgRatio}`

    this.products = []
    this.containers = $list(this.containerAttribute, this)
  }

  async mountComponent(): Promise<void> {
    await this.fetchItems()

    if (this.products.length > 0) {
      this.setItems()
      this.setVisible(true)
    }
  }

  fetchItems = async (): Promise<void> => {
    const { origin } = window.location
    const locale = window.Shopify.routes.root ?? '/'

    const currentSavedProducts = JSON.parse(
      localStorage.getItem(this.localStorageSelector),
    )?.slice(0, this.cardLimit)

    if (!currentSavedProducts) {
      return
    }

    try {
      for (const handle of currentSavedProducts) {
        const section = await fetch(
          `${origin}${locale}products/${handle}?sections=product-card-template`,
        ).then(res => res.json())

        const node = this.createNodeByString(
          section[this.cardTemplateSelector],
        ) as HTMLElement

        if (node) {
          this.products.push(node)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  setItems = (): void => {
    this.containers.forEach(container => {
      const products = this.products.map(product => product.cloneNode(true))
      container.replaceChildren(...products)
    })
  }

  setVisible(isVisible: boolean): void {
    this.classList.toggle('hidden', !isVisible)
  }

  createNodeByString(productString: string): Element | null {
    const html = new DOMParser().parseFromString(productString, 'text/html')
    const node = $el(`.${this.cardTemplateSelector}`, html)

    $el(this.cardSelector, node)?.classList.add(this.cardAlignmentClass)
    $el(this.cardInnerSelector, node)?.classList.add(this.shapeClass)

    return node
  }

  static updateProductsInLocalStorage(handle: string): void {
    if (!handle) {
      return
    }

    const currentSavedProducts =
      JSON.parse(localStorage.getItem(this.localStorageSelector)) ?? []

    const isExist = currentSavedProducts?.find(
      (item: string) => item === handle,
    )

    const newProducts = isExist
      ? currentSavedProducts
      : [handle, ...currentSavedProducts].slice(0, this.defaultLimit)

    localStorage.setItem(this.localStorageSelector, JSON.stringify(newProducts))
  }
}
